import { Component, OnInit, ViewChild, ElementRef, Output, Input,EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss']
})

export class DeleteConfirmationComponent implements OnInit {

  @ViewChild('container', { static: true }) container: ElementRef;
  
  @Output() send = new EventEmitter<any>();
  @Input() SignedDocument: boolean = true;

  constructor(
    private modalService: NgbModal,
    ) { }

  ngOnInit(): void {
  }

  open() {
    this.modalService.open(this.container, { ariaLabelledBy: 'modal-basic-title' });
  }

  close() {
    this.modalService.dismissAll('Closed');
  }

  sendEvent() {
    this.send.emit();
  }
 
}
